
<!-- TODO: Ajouter un champ vertical/horizontal et en gérer la logique ici -->
<hr :class="jel_getClassObject(content)" />
